import z from 'zod';

export const collectPaymentPublicFormSchema = z.object({
  internalPaymentToken: z.string(),
  gatewayPaymentToken: z.string(),

  payment: z.object({
    amount: z.number(),
    currency: z.string(),
  }),

  billing: z.object({
    firstName: z.string(),
    lastName: z.string(),
    address1: z.string(),
    zip: z.string(),
    email: z.string(),
  }),
});

export type CollectPaymentPublicForm = z.infer<
  typeof collectPaymentPublicFormSchema
>;
